import axios from 'axios';
import * as ETVConstants from '../ETVConstants';

export function validateSurveyAnswers(answers) {
  if (!Array.isArray(answers) || answers.length < 2 || answers.length > 5) return 'Provide between two and five answers.';
  if (answers.some((answer) => typeof answer !== 'string' || !answer.trim())) return 'Fill in each answer, or remove unused answers.';
  if (answers.some((answer) => answer.length > 240)) return 'Keep each answer within 240 characters.';
  if (new Set(answers.map((answer) => answer.trim().toLowerCase())).size !== answers.length) return 'Each answer must be different.';
  return '';
}


async function readResponse(response, fallback) {
  const raw = await response.text();
  let data;
  try { data = JSON.parse(raw); } catch { throw new Error(fallback); }
  if (!response.ok || data?.result === false || data?.result === 'false') throw new Error(data?.error || data?.message || fallback);
  return data;
}

/** Uses the existing upload and survey APIs. The server attaches the live QR. */
export async function saveSurvey({ userId, question, imageData, ratio, screens, channel, uploadCache, surveyType = 'satisfaction', answers = [] }) {
  if (!question.trim()) throw new Error('Please enter a survey question.');
  const general = surveyType === 'general';
  const answerError = general ? validateSurveyAnswers(answers) : '';
  if (answerError) throw new Error(answerError);
  const choices = general ? answers.map((answer) => answer.trim()) : ['excellent', 'good', 'average', 'poor', 'very_poor'];
  const auth = { user_id: localStorage.getItem('etv.user_id') || String(userId), access_token: localStorage.getItem('etv.access_token') || '' };
  const targetDir = `/${userId}/content_library`;
  if (!uploadCache.current || uploadCache.current.imageData !== imageData) {
    const filename = `${Date.now()}_survey.png`;
    const request = new URLSearchParams({ action: 'request_upload', user_id: String(userId), target_dir: targetDir, filename });
    const upload = await readResponse(await fetch(`${ETVConstants.getServerBase()}/content_library?${request}`, { headers: auth }), 'Could not prepare the image upload.');
    if (!upload.url || !upload.fields) throw new Error('Could not prepare the image upload.');
    const bytes = Uint8Array.from(atob(imageData.split(',')[1]), (character) => character.charCodeAt(0));
    const file = new File([bytes], filename, { type: 'image/png' }), body = new FormData();
    Object.entries(upload.fields).forEach(([key, value]) => body.append(key, value)); body.append('file', file);
    await axios.post(upload.url, body);
    uploadCache.current = { imageData, filename, size: file.size };
  }
  const params = new URLSearchParams({
    action: 'create_survey', survey_type: general ? '1' : '0', question: question.trim(), user_id: String(userId),
    channel: String(channel), target_dir: targetDir, virtual_dir: '/', content_ratio: String(ratio),
    filename: uploadCache.current.filename, file_size: String(uploadCache.current.size),
  });
  choices.forEach((answer, index) => params.append(`ans_${index + 1}`, answer));
  screens.forEach((id) => params.append('device_id', String(id)));
  const saved = await readResponse(await fetch(`${ETVConstants.getServerBase()}/survey_mgmt?${params}`, { headers: auth }), 'Could not create the survey. Your design has been kept so you can retry.');
  if (!saved?.survey_id || Number(saved.survey_id) <= 0) throw new Error('The survey was not confirmed. Please retry.');
  return saved;
}
